import { defineDirective } from '~/scripts/utils/alpine'

export default defineDirective((element, { expression }, { evaluate }) => {
  // Define desktop and mobile speed factors from expression or defaults
  const defaultDesktopSpeed = 0.2
  const defaultMobileSpeed = 0.1
  let desktopSpeed: number = defaultDesktopSpeed
  let mobileSpeed: number = defaultMobileSpeed
  if (expression) {
    const raw = expression.trim()
    if (raw.includes(',')) {
      const [dExpr, mExpr] = raw.split(',')
      desktopSpeed = Number(evaluate(dExpr))
      mobileSpeed = Number(evaluate(mExpr))
    } else {
      desktopSpeed = Number(evaluate(raw))
      mobileSpeed = desktopSpeed * 0.5
    }
  }

  // Update element position based on scroll inside its section
  function update() {
    const sectionElement = element.closest('section')
    const scrollY = globalThis.scrollY
    const sectionTop = sectionElement?.offsetTop ?? 0
    const sectionHeight = sectionElement?.offsetHeight ?? 0
    // Calculate scroll progress within section (clamp between 0 and sectionHeight)
    const relative = Math.min(Math.max(scrollY - sectionTop, 0), sectionHeight)
    // Choose speed based on viewport width (<768px -> mobileSpeed; else desktopSpeed)
    const appliedSpeed =
      globalThis.innerWidth < 768 ? mobileSpeed : desktopSpeed
    const offset = relative * appliedSpeed
    element.style.transform = `translateY(${offset}px)`
  }

  let ticking = false

  // Scroll event handler with requestAnimationFrame for performance
  function onScroll() {
    if (!ticking) {
      globalThis.requestAnimationFrame(() => {
        update()
        ticking = false
      })
      ticking = true
    }
  }

  globalThis.addEventListener('scroll', onScroll, { passive: true })

  // Initial position update
  update()
})
